
<!-- TODO: replace animation class -->
<transition-group
  tag="div"
  class="sdv-activation-preview-list"
  :enter-active-class="internalAnimation.enter"
  :leave-active-class="internalAnimation.leave"
  appear
>
  <template
    v-for="({ activation, context, itemKey, itemClass }) in internalItems"
  >
    <slot
      name="item"
      :item="{ activation, context, itemKey, itemClass }"
      :on="listListeners"
    >
      <ActivationSmartblockList
        :key="itemKey"
        :class="itemClass"
        :activation="activation"
        :context="context"
        preview
        v-on="listListeners"
      />
    </slot>
  </template>
</transition-group>
